module.exports = __webpack_public_path__ + "8b99c5dd47e8ded260e5a0c7acd83f8c.pdf";